import Modal from "react-bootstrap/Modal";
import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import "../../Style/Checkbox.scss";
import { errorAlert, handleSuccess, getApiErrorMessage } from "../../Components/Alerts";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import "../../Style/__button.scss";
import AddBoxIcon from "@mui/icons-material/AddBox";
import "./SuppliersModal.scss";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "react-select";
import { AddElementsButton } from "../../Components/AddElementsButton";
import InputAdornment from "@mui/material/InputAdornment";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import Tooltip from "@mui/material/Tooltip";

function InsertSuppliers(props) {
  const headers = authHeader();
  const isEditMode = props.mode === "edit";
  const normalizeBankAccount = (value = "") => value.replace(/\D/g, "");
  const formatBankAccount = (value = "") =>
    normalizeBankAccount(value).replace(/(.{4})/g, "$1 ").trim();
  const [data, setData] = useState([]);
  const [findIdentificationNr, setFindIdentificationNr] = useState("");
  const [idNumberExist, setIDNumberExist] = useState(false);
  const [accountID, setAccountID] = useState(null);

  const [AccName, setAccName] = useState("");
  const [IdNumber, setIdNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [adress, setAdress] = useState("");
  const [cityID, setCityID] = useState("");

  const [bankID, setBankID] = useState();
  const [bankAccount, setBankAccount] = useState("");
  const [accEmail, setAccEmail] = useState("");
  const [comment, setComment] = useState("");
  const [phone, setPhone] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialSnapshotRef = useRef(null);
  const [showConfirmClose, setShowConfirmClose] = useState(false);

  const [stateid, setStateID] = useState("");

  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);

  const [city, setCity] = useState([]);
  const [filteredCity, setFilteredCity] = useState([]);

  const [bank, setBank] = useState([]);
  const [filteredBank, setFilteredBank] = useState([]);

  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");
  const [accNameError, setAccNameError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [idNumberEror, setIdNumberError] = useState("");
  const [vatError, setVatError] = useState("");
  const [bankAccountError, setBankAccountError] = useState("");

  const [supplierType, setSupplierType] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [bankName, setBankName] = useState("");

  const resetForm = () => {
    setAccountID(null);
    setAccName("");
    setIdNumber("");
    setVatNumber("");
    setAdress("");
    setCityID("");
    setStateID("");
    setBankID(undefined);
    setBankAccount("");
    setAccEmail("");
    setComment("");
    setPhone("");
    setIsActive(true);
    setStateName("");
    setCityName("");
    setBankName("");
    setSupplierType("");
    setStateError("");
    setCityError("");
    setAccNameError("");
    setAddressError("");
    setIdNumberError("");
    setVatError("");
    setBankAccountError("");
    setFindIdentificationNr("");
    setIDNumberExist(false);
    setIsSubmitting(false);
    initialSnapshotRef.current = null;
    setShowConfirmClose(false);
  };

  const setFormFromSupplier = (supplier) => {
    const formattedBankAccount = formatBankAccount(supplier?.BankAccount ?? "");

    setAccountID(supplier?.AccountID ?? null);
    setAccName(supplier?.AccountName ?? "");
    setIdNumber(supplier?.IdentificationNumber ?? "");
    setFindIdentificationNr(supplier?.IdentificationNumber ?? "");
    setVatNumber(supplier?.VATNumber ?? "");
    setAdress(supplier?.Adress ?? "");
    setStateID(supplier?.StateID ?? "");
    setCityID(supplier?.CityID ?? "");
    setBankID(supplier?.BankID ?? undefined);
    setBankAccount(formattedBankAccount);
    setAccEmail(supplier?.Email ?? "");
    setComment(supplier?.Comment ?? "");
    setPhone(supplier?.PhoneNumbers ?? "");
    setIsActive(typeof supplier?.IsActive === "boolean" ? supplier.IsActive : true);
    setStateName(supplier?.StateName ?? "");
    setCityName(supplier?.CityName ?? "");
    setBankName(supplier?.BankName ?? "");
    setStateError("");
    setCityError("");
    setAccNameError("");
    setAddressError("");
    setIdNumberError("");
    setVatError("");
    setBankAccountError("");
    initialSnapshotRef.current = {
      AccName: supplier?.AccountName ?? "",
      IdNumber: supplier?.IdentificationNumber ?? "",
      vatNumber: supplier?.VATNumber ?? "",
      adress: supplier?.Adress ?? "",
      stateid: supplier?.StateID ?? "",
      cityID: supplier?.CityID ?? "",
      bankID: supplier?.BankID ?? undefined,
      bankAccount: formattedBankAccount,
      accEmail: supplier?.Email ?? "",
      comment: supplier?.Comment ?? "",
      phone: supplier?.PhoneNumbers ?? "",
      isActive: typeof supplier?.IsActive === "boolean" ? supplier.IsActive : true,
    };
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (isSubmitting) {
      return;
    }

    let hasValidationError = false;
    const normalizedBankAccount = normalizeBankAccount(bankAccount);

    if (AccName.trim() === "") {
      setAccNameError("Plotësoni emrin e furnitorit");
      hasValidationError = true;
    } else {
      setAccNameError("");
    }

    if (adress.trim() === "") {
      setAddressError("Plotësoni adresën");
      hasValidationError = true;
    } else {
      setAddressError("");
    }

    if (IdNumber == null || IdNumber === "") {
      setIdNumberError("Plotësoni numrin identifikues");
      hasValidationError = true;
    }

    if (IdNumber.length > 15) {
      setIdNumberError(
        "Numri identifikues nuk duhet te ketë më shumë se 15 karaktere",
      );
      hasValidationError = true;
    }

    if (idNumberExist) {
      setIdNumberError("Furnitori me këtë numër identifikues ekziston");
      hasValidationError = true;
    }

    if (vatNumber.length > 15) {
      setVatError("Numri i TVSH nuk duhet te ketë më shumë se 15 karaktere");
      hasValidationError = true;
    } else {
      setVatError("");
    }

    if (normalizedBankAccount !== "") {
      const isBankAccountValid = normalizedBankAccount.length === 16;
      if (!isBankAccountValid) {
        setBankAccountError("Llogaria bankare duhet të jetë fiks 16 shifra");
        hasValidationError = true;
      } else {
        setBankAccountError("");
      }
    } else {
      setBankAccountError("");
    }

    if (stateid == null || stateid === "") {
      setStateError("Përzgjedh shtetin");
      hasValidationError = true;
    } else {
      setStateError("");
    }

    if (cityID == null || cityID === "") {
      setCityError("Përzgjedh qytetin");
      hasValidationError = true;
    } else {
      setCityError("");
    }

    if (hasValidationError) {
      return;
    }

    setIdNumberError("");
    setIsSubmitting(true);

    const payload = {
      AccountName: AccName,
      LedgerID: 302,
      IdentificationNumber: IdNumber,
      VATNumber: vatNumber,
      Adress: adress,
      CityID: cityID,
      StateID: stateid,
      BankID: bankID,
      BankAccount: normalizedBankAccount,
      Email: accEmail,
      Comment: comment,
      PhoneNumbers: phone,
      IsActive: isActive,
      ...(isEditMode
        ? {
            AccountID: accountID,
          }
        : {}),
    };

    const submitRequest = isEditMode
      ? axios.put(ApiLink.API_URL + "Accounts/updateAccount", payload, { headers })
      : axios.post(ApiLink.API_URL + "Accounts/insertAccount", payload, { headers });

    submitRequest
      .then(() => {
        handleSuccess(isEditMode ? "Furnitori u përditësua me sukses" : "Furnitori u shtua me sukses");
        resetForm();
        props.onHide();
        props.refreshData();
      })
      .catch((error) => {
        console.error(error);
        if (error.response && error.response.status === 409) {
          errorAlert(error.response.data);
        } else {
          errorAlert("Ndodhi një gabim i panjohur gjatë përpunimit të kërkesës.");
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "states", { headers })
      .then((response) => {
        setStates(response.data);
      })
      .catch((error) => {
        console.error(error);
        errorAlert(getApiErrorMessage(error, "Gabim i panjohur në marrjen e shteteve."));
      });
  }, []);

  useEffect(() => {
    if (!props.show) {
      return;
    }

    if (isEditMode) {
      if (!props.initialData) {
        return;
      }

      setFormFromSupplier(props.initialData);
      if (props.initialData.StateID) {
        fetchCityByState(props.initialData.StateID);
      }
      return;
    }

    resetForm();
  }, [props.show, isEditMode, props.initialData]);

  const fetchCityByState = async (selectedStateID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Cities/getcitybystate",
        { headers, params: { stateid: selectedStateID } },
      );
      setCity(response.data);
    } catch (error) {
      errorAlert(getApiErrorMessage(error, "Gabim i panjohur në kërkesë. Shih konsolën për detaje."));
    }
  };

  const isDirty = useMemo(() => {
    if (!isEditMode) {
      return (
        AccName.trim() !== "" ||
        IdNumber !== "" ||
        vatNumber !== "" ||
        adress.trim() !== "" ||
        stateid !== "" ||
        cityID !== "" ||
        bankID != null ||
        bankAccount !== "" ||
        accEmail !== "" ||
        comment !== "" ||
        phone !== ""
      );
    }
    const snap = initialSnapshotRef.current;
    if (!snap) return false;
    return (
      AccName !== snap.AccName ||
      IdNumber !== snap.IdNumber ||
      vatNumber !== snap.vatNumber ||
      adress !== snap.adress ||
      stateid !== snap.stateid ||
      cityID !== snap.cityID ||
      bankID !== snap.bankID ||
      bankAccount !== snap.bankAccount ||
      accEmail !== snap.accEmail ||
      comment !== snap.comment ||
      phone !== snap.phone ||
      isActive !== snap.isActive
    );
  }, [isEditMode, AccName, IdNumber, vatNumber, adress, stateid, cityID,
    bankID, bankAccount, accEmail, comment, phone, isActive]);

  const doClose = () => {
    props.onHide();
    resetForm();
  };

  const handleClose = () => {
    if (isDirty) {
      setShowConfirmClose(true);
      return;
    }
    doClose();
  };

  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "LicencedBanks", { headers })
      .then((response) => {
        setBank(response.data);
      })
      .catch((error) => {
        errorAlert(getApiErrorMessage(error, "Gabim i panjohur në marrjen e bankave."));
      });
  }, []);

  useEffect(() => {
    setFilteredStates(
      states.filter((item) =>
        item.StateName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, states]);

  useEffect(() => {
    setFilteredCity(
      city.filter((item) =>
        item.CityName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, city]);

  useEffect(() => {
    setFilteredBank(
      bank.filter((item) =>
        item.BankName.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    );
  }, [searchTerm, bank]);

  const handleInputChange = (newValue) => {
    const inputValue = newValue.replace(/\W/g, "");
    setSearchTerm(inputValue);
  };

  const handleFilterState = (selectedOption) => {
    if (selectedOption && selectedOption.StateID) {
      setStateID(selectedOption.StateID);
      setCityID("");
      setCityName("");
      setCity([]);
      fetchCityByState(selectedOption.StateID);
      setStateName(selectedOption.label);
      setStateError("");
      setCityError("");
    } else {
      setStateID("");
      setStateName("");
      setCityID("");
      setCityName("");
      setCity([]);
    }
  };

  const handleFilterCity = (selectedOption) => {
    if (selectedOption && selectedOption.CityID) {
      setCityID(selectedOption.CityID);
      setCityName(selectedOption.label);
      setCityError("");
    } else {
      setCityID("");
      setCityName("");
    }
  };

  const handleFilterBank = (selectedOption) => {
    if (!selectedOption) {
      setBankID(undefined);
      setBankName("");
      setBankAccount("");
      setBankAccountError("");
      return;
    }

    if (selectedOption.BankID !== bankID) {
      setBankAccount("");
      setBankAccountError("");
    }

    setBankID(selectedOption.BankID);
    setBankName(selectedOption.label);
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Accounts/accountByLedger",
        { headers, params: { ledger: 302 } },
      );
      setData(response.data);
    } catch (error) {
      errorAlert(getApiErrorMessage(error, "Gabim i panjohur në kërkesë. Shih konsolën për detaje."));
    }
  };

  const generateNUI = () => {
    const d = new Date();
    const year = String(d.getFullYear()).slice(2);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const random = Math.floor(1000 + Math.random() * 9000);
    setIdNumber(`SUP${year}${month}${day}${random}`);
  };

  const checkIdNumber = () => {
    const filteredData = data.filter((item) => {
      return (
        item.IdentificationNumber &&
        item.IdentificationNumber.includes(findIdentificationNr) &&
        !["1", "8"].includes(findIdentificationNr)
      );
    });

    const hasDuplicate = filteredData.some((item) => {
      if (item.IdentificationNumber !== IdNumber) {
        return false;
      }

      if (isEditMode && accountID != null) {
        return item.AccountID !== accountID;
      }

      return true;
    });

    if (hasDuplicate) {
      setIdNumberError("Furnitori me këtë numër identifikues ekziston");
      setIDNumberExist(true);
    } else {
      setIdNumberError("");
      setIDNumberExist(false);
    }
  };

  useEffect(() => {
    const id = IdNumber.trim();
    if (id.length > 15) {
      setIdNumberError("Identification number must be between 0-15 numbers");
      return;
    }
    setIdNumberError("");

    if (id.length === 10) {
      setSupplierType(
        "Ky është një numër personal identifikues për një person fizik",
      );
    } else if (id.length === 9 && id.startsWith("6")) {
      setSupplierType("Ky numër i përket një organizate");
    } else if (id.length === 9 && id.startsWith("8")) {
      setSupplierType(
        "Ky numër i përket një kompanie të regjistruar për veprimtari biznesi",
      );
    } else {
      setSupplierType("");
    }
  }, [IdNumber]);

  useEffect(() => {
    checkIdNumber();
  }, [IdNumber, findIdentificationNr, data, isEditMode, accountID]);

  useEffect(() => {
    if (!stateid || stateName) {
      return;
    }

    const match = states.find((item) => item.StateID === stateid);
    if (match) {
      setStateName(match.StateName);
    }
  }, [stateid, stateName, states]);

  useEffect(() => {
    if (!cityID || cityName) {
      return;
    }

    const match = city.find((item) => item.CityID === cityID);
    if (match) {
      setCityName(match.CityName);
    }
  }, [cityID, cityName, city]);

  useEffect(() => {
    if (bankID == null || bankName) {
      return;
    }

    const match = bank.find((item) => item.BankID === bankID);
    if (match) {
      setBankName(match.BankName);
    }
  }, [bankID, bankName, bank]);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
    <Modal
      {...props}
      onHide={handleClose}
      size="lg"
      dialogClassName="suppliers-modal-dialog"
      contentClassName="suppliers-modal-content"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header className="suppliers-modal-header">
        <div className="suppliers-modal-header-content">
          <Modal.Title id="contained-modal-title-vcenter" className="suppliers-modal-title">
            {isEditMode ? "Përditëso të dhënat e furnitorit" : "Krijo një furnitor të ri"}
          </Modal.Title>
          <p className="suppliers-modal-subtitle">
            {isEditMode
              ? "Ndrysho të dhënat e furnitorit dhe ruaji për përditësim në sistem."
              : "Plotësoni të dhënat e furnitorit dhe ruani për ta shtuar në sistem."}
          </p>
          <div className="suppliers-modal-meta">
            <span className="suppliers-meta-pill">Fushat me * janë obligative</span>
            <span className="suppliers-meta-pill suppliers-meta-pill-soft">
              Numri Identifikues: max 15 karaktere
            </span>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="suppliers-modal-body">
        <form onSubmit={handleSubmit} className="suppliers-form">
          <section className="suppliers-section">
            <h6 className="suppliers-section-title">Informata Kryesore</h6>
            <div className="suppliers-grid suppliers-grid-2">
              <div className="suppliers-field suppliers-field-full">
                <TextField
                  fullWidth
                  required
                  id="AccountName"
                  label="Emri i Furnitorit *"
                  variant="outlined"
                  type="text"
                  name="AccountName"
                  value={AccName}
                  onChange={(event) => {
                    setAccName(event.target.value);
                    if (accNameError) {
                      setAccNameError("");
                    }
                  }}
                  autoComplete="off"
                  size="small"
                />
                <span className="suppliers-error">{accNameError && `${accNameError}`}</span>
              </div>

              <div className="suppliers-field">
                <TextField
                  fullWidth
                  id="IdentificationNumber"
                  label="Numri Identifikues"
                  variant="outlined"
                  type="text"
                  name="IdentificationNumber"
                  value={IdNumber}
                  onChange={(event) => {
                    setIdNumber(event.target.value);
                    setFindIdentificationNr(event.target.value);
                    if (idNumberEror) {
                      setIdNumberError("");
                    }
                  }}
                  inputProps={{ maxLength: 15 }}
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip title="Gjenero random numër" placement="right">
                          <AutorenewIcon onClick={generateNUI} className="suppliers-generate-icon" />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
                <div className="suppliers-helper-row">
                  <span className={idNumberEror ? "suppliers-error" : "suppliers-success"}>
                    {idNumberEror || supplierType}
                  </span>
                  <span className={`suppliers-counter ${IdNumber.length > 13 ? "suppliers-counter-warning" : ""}`}>
                    {IdNumber.length}/15
                  </span>
                </div>
              </div>

              <div className="suppliers-field">
                <TextField
                  fullWidth
                  id="VATNumber"
                  label="Numri i TVSH-së"
                  variant="outlined"
                  type="text"
                  name="VATNumber"
                  value={vatNumber}
                  onChange={(event) => {
                    setVatNumber(event.target.value);
                    if (vatError) {
                      setVatError("");
                    }
                  }}
                  inputProps={{ maxLength: 15 }}
                  autoComplete="off"
                  size="small"
                />
                <div className="suppliers-helper-row">
                  <span className="suppliers-error">{vatError && `${vatError}`}</span>
                  <span className={`suppliers-counter ${vatNumber.length > 13 ? "suppliers-counter-warning" : ""}`}>
                    {vatNumber.length}/15
                  </span>
                </div>
              </div>

              <div className="suppliers-field suppliers-field-full">
                <TextField
                  fullWidth
                  required
                  id="Adress"
                  label="Adresa *"
                  variant="outlined"
                  type="text"
                  name="Adress"
                  value={adress}
                  onChange={(event) => {
                    setAdress(event.target.value);
                    if (addressError) {
                      setAddressError("");
                    }
                  }}
                  autoComplete="off"
                  size="small"
                />
                <span className="suppliers-error">{addressError && `${addressError}`}</span>
              </div>

              <div className="suppliers-field">
                <label className="suppliers-select-label">Përzgjedh Shtetin *</label>
                <Select
                  inputId="StateID"
                  classNamePrefix="suppliers-select"
                  value={stateid ? { label: stateName, value: stateid, StateID: stateid } : null}
                  options={filteredStates.map((item) => ({
                    label: item.StateName,
                    value: item.StateID,
                    StateID: item.StateID,
                  }))}
                  onInputChange={handleInputChange}
                  onChange={handleFilterState}
                  isClearable
                  placeholder="Select"
                  noOptionsMessage={() => "No matching"}
                  components={{ IndicatorSeparator: () => null }}
                />
                <span className="suppliers-error">{stateError && `${stateError}`}</span>
              </div>

              <div className="suppliers-field">
                <label className="suppliers-select-label">Përzgjedh Qytetin *</label>
                <Select
                  inputId="CityID"
                  classNamePrefix="suppliers-select"
                  value={cityID ? { label: cityName, value: cityID, CityID: cityID } : null}
                  options={filteredCity.map((item) => ({
                    label: item.CityName,
                    value: item.CityID,
                    CityID: item.CityID,
                  }))}
                  onInputChange={handleInputChange}
                  onChange={handleFilterCity}
                  isClearable
                  placeholder="Select"
                  noOptionsMessage={() => "No matching"}
                  components={{ IndicatorSeparator: () => null }}
                />
                <span className="suppliers-error">{cityError && `${cityError}`}</span>
              </div>
            </div>
          </section>

          <section className="suppliers-section">
            <h6 className="suppliers-section-title">Detaje Financiare</h6>
            <div className="suppliers-grid suppliers-grid-2">
              <div className="suppliers-field">
                <label className="suppliers-select-label">Përzgjedh bankën</label>
                <Select
                  inputId="BankID"
                  classNamePrefix="suppliers-select"
                  value={bankID ? { label: bankName, value: bankID, BankID: bankID } : null}
                  options={filteredBank.map((item) => ({
                    label: item.BankName,
                    value: item.BankID,
                    BankID: item.BankID,
                  }))}
                  onInputChange={handleInputChange}
                  onChange={handleFilterBank}
                  isClearable
                  placeholder="Select"
                  noOptionsMessage={() => "No matching"}
                  components={{ IndicatorSeparator: () => null }}
                />
              </div>

              <div className="suppliers-field">
                <label className="suppliers-select-label">Numri i Llogarisë</label>
                <TextField
                  fullWidth
                  id="BankAccount"
                  variant="outlined"
                  type="text"
                  name="BankAccount"
                  value={bankAccount}
                  onChange={(event) => {
                    setBankAccount(formatBankAccount(event.target.value));
                    if (bankAccountError) {
                      setBankAccountError("");
                    }
                  }}
                  inputProps={{ maxLength: 19 }}
                  autoComplete="off"
                  disabled={!bankID}
                  placeholder={bankID ? "Shkruaj numrin e llogarisë" : "Fillimisht zgjidh bankën"}
                  size="small"
                />
                <span className="suppliers-error">
                  {bankAccountError && `${bankAccountError}`}
                </span>
              </div>
            </div>
          </section>

          <section className="suppliers-section">
            <h6 className="suppliers-section-title">Kontakt dhe Koment</h6>
            <div className="suppliers-grid suppliers-grid-2">
              <div className="suppliers-field">
                <TextField
                  fullWidth
                  id="Email"
                  label="Email"
                  variant="outlined"
                  type="email"
                  name="Email"
                  value={accEmail}
                  onChange={(event) => setAccEmail(event.target.value)}
                  autoComplete="off"
                  size="small"
                />
              </div>

              <div className="suppliers-field">
                <TextField
                  fullWidth
                  id="PhoneNumber"
                  label="Numri i Telefonit"
                  variant="outlined"
                  type="tel"
                  name="PhoneNumber"
                  value={phone}
                  onChange={(event) => setPhone(event.target.value)}
                  autoComplete="off"
                  size="small"
                />
              </div>

              <div className="suppliers-field suppliers-field-full">
                <textarea
                  rows={2}
                  className="suppliers-notes"
                  id="Comment"
                  placeholder="Komenti"
                  name="Comment"
                  value={comment}
                  onChange={(event) => setComment(event.target.value)}
                  autoComplete="off"
                />
              </div>

              {isEditMode && (
                <div className="suppliers-field suppliers-field-full">
                  <label className="suppliers-active-toggle">
                    <input
                      type="checkbox"
                      className="suppliers-active-checkbox"
                      checked={Boolean(isActive)}
                      onChange={(event) => setIsActive(event.target.checked)}
                      disabled={isSubmitting}
                    />
                    <span className="suppliers-active-copy">
                      <span className="suppliers-active-title">Statusi i furnitorit</span>
                      <span className="suppliers-active-description">
                        {isActive ? "Furnitori është aktiv në sistem" : "Furnitori është joaktiv në sistem"}
                      </span>
                    </span>
                  </label>
                </div>
              )}
            </div>
          </section>

          <div className="suppliers-modal-footer">
            <Button
              type="submit"
              variant="contained"
              className="suppliers-save-btn"
              disabled={isSubmitting || (isEditMode && !isDirty)}
            >
              {isSubmitting
                ? "Duke ruajtur..."
                : isEditMode
                  ? "Përditëso & Mbyll"
                  : "Ruaj & Mbyll"}
            </Button>
            <Button
              variant="outlined"
              className="suppliers-close-btn"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Mbyll
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>

    <Dialog
      open={showConfirmClose}
      onClose={() => setShowConfirmClose(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{ className: "suppliers-confirm-dialog" }}
    >
      <DialogTitle>Konfirmo mbylljen</DialogTitle>
      <DialogContent>
        Keni ndryshime të paruajtura. Nëse mbyllni tani, të dhënat e ndryshuara do të humbin. A jeni të sigurt?
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowConfirmClose(false)} variant="outlined">
          Kthehu
        </Button>
        <Button onClick={doClose} variant="contained" color="error">
          Po, mbyll pa ruajtur
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
}

export default function SuppliersModal(props) {
  const [internalModalShow, setInternalModalShow] = React.useState(false);
  const isControlled = typeof props.show === "boolean";
  const modalShow = isControlled ? props.show : internalModalShow;

  const openModal = () => {
    if (isControlled) {
      return;
    }

    setInternalModalShow(true);
  };

  const closeModal = () => {
    if (isControlled) {
      if (props.onHide) {
        props.onHide();
      }
      return;
    }

    setInternalModalShow(false);
  };

  const handleRefreshData = () => {
    if (props.fetchData) {
      props.fetchData();
    }
  };

  return (
    <>
      {!isControlled &&
        (props.type === "text" ? (
          <AddElementsButton
            text="Krijo Furnitor"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-68"
          />
        ) : props.type === "insert" ? (
          <AddElementsButton
            text="Krijo Furnitor"
            onClick={openModal}
            icon="bi bi-plus-circle"
            className="button-15"
          />
        ) : props.type === "none" ? null : (
          <AddBoxIcon
            style={{ height: "30px", color: "black" }}
            onClick={openModal}
          />
        ))}

      <InsertSuppliers
        show={modalShow}
        onHide={closeModal}
        refreshData={handleRefreshData}
        mode={props.mode}
        initialData={props.initialData}
      />
    </>
  );
}
